export const RUN_PLAYGROUND_TOOL_NAME = "run_playground";
export const CANCEL_PLAYGROUND_RUN_TOOL_NAME = "cancel_playground_run";
